import React from "react";

import { IconProps } from "./../types";
import { BaseSVGIcon } from "./base-svg-icon";

export const OutOfTime24Variation: React.FC<IconProps> = (props) => {
  return (
    <BaseSVGIcon width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
        fill="currentColor"
      />
      <path
        d="M12 15C12.5523 15 13 15.4477 13 16C13 16.5522 12.5523 17 12 17C11.4477 17 11 16.5522 11 16C11 15.4477 11.4477 15 12 15ZM12 6.99996C12.1404 6.99908 12.2798 7.02817 12.4082 7.08492C12.5365 7.14165 12.6513 7.2248 12.7451 7.32906C12.839 7.43342 12.9093 7.55674 12.9522 7.69039C12.995 7.82411 13.0099 7.96589 12.9941 8.10543L12.6152 12.9736C12.5968 13.1222 12.524 13.259 12.4102 13.3564C12.2963 13.4538 12.1498 13.5048 12 13.5C11.8502 13.5048 11.7037 13.4538 11.5898 13.3564C11.476 13.259 11.4032 13.1222 11.3848 12.9736L11.0059 8.10543C10.9901 7.96589 11.005 7.82411 11.0479 7.69039C11.0907 7.55674 11.161 7.43342 11.2549 7.32906C11.3487 7.2248 11.4635 7.14165 11.5918 7.08492C11.7202 7.02817 11.8596 6.99908 12 6.99996Z"
        fill="currentColor"
      />
    </BaseSVGIcon>
  );
};
